export function RedirectDB() {
  window.location.replace('https://db.gcsim.app');
  return (
    <div>
      Please visit the new db at{' '}
      <a href="https://db.gcsim.app">https://db.gcsim.app</a>
    </div>
  );
}
